import { CheckMarkIconStacked, ExclamationMarkIconStacked, InfoMarkIconStacked, WarningIcon } from '@dhl-ui/icons'
import type { AlertProps } from './types'

export const getIcon = (severity: AlertProps['severity']) => {
  switch (severity) {
    case 'success':
      return <CheckMarkIconStacked />
    case 'warning':
      return <WarningIcon />
    case 'error':
      return <ExclamationMarkIconStacked />
    case 'info':
    default:
      return <InfoMarkIconStacked />
  }
}
